
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `轻触“在浏览器中打开…”`,
's182ab2d6c997515f': `将其添加到主屏幕，以享受更丰富的体验并便于访问。`,
's224cbcec014ef6b5': `点击导航栏中的“分享”按钮`,
's233af3b7eb5e0364': `添加到主页`,
's37a9e8aec5713460': `更多`,
's4c3161035f3a1413': `请点击菜单`,
's4e1e10a6ca408245': `轻触“添加到主屏幕”`,
's6196153c4b0c1ea0': `安装`,
's633502f7cff4f847': `打开浏览器菜单`,
's681e399d63311fba': `显示图库`,
's6d14a4f70ba4e3cf': `如果没有分享图标，请点击菜单`,
's922329d6f6213590': `添加到程序坞`,
's9c63a79ffcc2a3a3': `点击“添加到主屏幕”`,
'sa2d71bfd9525168d': `点击“添加到程序坞”`,
'sa5ef80b4bb9b39f8': `收起`,
'sb527eca1c1d7e7be': `打开应用内浏览器菜单`,
'sba52286c21552a4e': `在您的设备上安装，以享受更丰富的体验并便于访问。`,
'sc16e00a7a8b2fde2': `返回`,
'scdaf4bbff76674c8': `添加到主屏幕`,
'sd18a5b85f599ff3c': `在 Safari 中打开已复制的链接`,
'se72fc3a84f9b51c3': `点击复制链接`,
'se740f75b95a51807': `将其添加到您的程序坞，以享受更全面的体验并便于访问。`,
'sfa6c42cdf48d93d2': `但此浏览器不支持该功能。请在外部浏览器中打开链接以继续。`,
'sfb78526365796a41': `在分享菜单中点击“查看更多”`,
'sfea652f6580ff086': `此网站具备 App 功能特性。`,
    };
  